export default "/img/FI.6b673c653c737b797d52ca54086a9e28.png";